import { GetStaticProps } from 'next';
import Head from 'next/head';
import AboutUsComponent from '../src/components/AboutUs';
import { getCanonicalUrl } from '../src/utils/seoHelpers';
import { seoConfig } from '../src/config/seo.config';

export default function AboutUsPage() {
  const pageTitle = "About Us - TurfBooking.in | India's Leading Turf Booking Platform";
  const pageDescription = "Learn about TurfBooking.in - India's premier online platform for booking cricket turfs, football grounds, and box cricket venues. Our mission is to make sports accessible to everyone across 15+ cities.";
  const canonicalUrl = getCanonicalUrl('/about-us');
  const baseUrl = seoConfig.baseUrl;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content="about turfbooking, turf booking company, sports booking platform india, cricket turf booking service" />
        <link rel="canonical" href={canonicalUrl} />
        
        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={`${baseUrl}/TBlogo.png`} />
        
        {/* Twitter */}
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={`${baseUrl}/TBlogo.png`} />
        
        {/* Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "About TurfBooking.in",
              "description": pageDescription,
              "url": canonicalUrl,
              "mainEntity": {
                "@type": "Organization",
                "name": "TurfBooking.in",
                "url": baseUrl
              }
            })
          }}
        />
      </Head>
      <AboutUsComponent />
    </>
  );
}

// Converted to getStaticProps for static generation at build time
// This improves performance by pre-rendering the page instead of SSR on every request
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
